import script from "./DropdownServices.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownServices.vue?vue&type=script&setup=true&lang=js"

import "./DropdownServices.vue?vue&type=style&index=0&id=248c9fc7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-248c9fc7"]])

export default __exports__